// extracted by mini-css-extract-plugin
export default {"messageContainer":"JwmGdcXtpK94SEXGtlQg","subjectContainer":"TvzS2XkJ19IVs8M0HhA2"};